export const ChartUnit = 24;
export const ChartPad = Math.round(ChartUnit / 4);

export const ChartPalette = {
  blue: "#4af",
  orange: "#fa4",
  green: "#4f8",
  purple: "#a4f",
  white: "#fff",
  grey: "#888",
  red: "#f66",
} as const;

export interface ChartTheme {
  background: string;
  grid: string;
  axis: string;
  text: string;
  refLine: string;
  series: string;
  accent: string;
  selection: string;
  fillOpacity: number;
  bandOpacity: number;
  strokeWidth: number;
  guideOpacity: number;
  fontSize: number;
  labelSize: number;
}

export const ChartThemeDark: ChartTheme = {
  background: "#111",
  grid: "#1e1e1e",
  axis: "#2a2a2a",
  text: "#444",
  refLine: "#2a2a2a",
  series: ChartPalette.blue,
  accent: ChartPalette.orange,
  selection: ChartPalette.blue,
  fillOpacity: 0.08,
  bandOpacity: 0.12,
  strokeWidth: 1.5,
  guideOpacity: 0.3,
  fontSize: 7,
  labelSize: 8,
};

export const ChartThemeLight: ChartTheme = {
  background: "#fafafa",
  grid: "#eee",
  axis: "#ccc",
  text: "#999",
  refLine: "#ddd",
  series: "#26c",
  accent: "#e90",
  selection: "#26c",
  fillOpacity: 0.1,
  bandOpacity: 0.15,
  strokeWidth: 1.5,
  guideOpacity: 0.4,
  fontSize: 7,
  labelSize: 8,
};
